import SegmentedList from './components/segmented-list'
import SegmentedRoot from './components/segmented-root'
import SegmentedTrigger from './components/segmented-trigger'

const SegmentedPickerComponent = {
  Root: SegmentedRoot,
  List: SegmentedList,
  Trigger: SegmentedTrigger
}

export default SegmentedPickerComponent
